import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Constants from "../utils/Constants";
import AuthorizedUser from "../utils/AuthorizedUser";
//import { usePrevious } from "../utils/CustomHooks";

import {
	makeStyles,
	Avatar as MUIAvatar
} from '@material-ui/core';

const styles = makeStyles(theme => ({
	avatarSmallest: {
		width: 30,
		height: 30
	},

	avatarSmaller: {
		width: 38,
		height: 38
	},

	avatar: {
		width: 48,
		height: 48,
		position: "relative"
	},

	avatarBigger: {
		width: 64,
		height: 64
	},

	avatarBiggest: {
		width: Constants.USER.AVATAR.SIZE.WIDTH,
		height: Constants.USER.AVATAR.SIZE.HEIGHT
	},

	circle: {
		borderRadius: "50%"
	},

	avatarInitials: {
		zIndex: 1,
		display: "flex",
		justifyContent: "center",
		flexDirection: "column",
		textAlign: "center",
		position: "absolute"
	},

	iconFallbackContainer: {
		display: "flex",
		justifyContent: "center",
		color: theme.palette.primary.grey
	},

	iconFallback: {
		zIndex: 1,
		position: "absolute",
		fontSize: "2.8rem",
		width: "0.65em !important"
	},

	primaryTextColor: {
		color: theme.palette.primary.main
	},

	defaultTextColor: {
		color: theme.palette.primary.grey
	},

	primaryCircleColor: {
		backgroundColor: theme.palette.primary.main
	},

	defaultCircleColor: {
		backgroundColor: theme.palette.primary.mediumGrey
	},

	moreContrastCircleColor: {
		backgroundColor: theme.palette.accessibilityColors.text.secondary
	},

	moreContrastText: {
		color: theme.palette.common.white
	}
}));

function Avatar(props) {
	const [brokenImage, setBrokenImage] = useState(false);

	/*const prevAuthorImage = usePrevious(props.authorImage);
	useEffect(() => {
		if (props.authorImage !== prevAuthorImage) {
			setBrokenImage(false);
		}
	});
	OR (see below)
	any time props.authorImage changes, the hook will be called
	*/
	useEffect(() => {
		if (props.authorImage) {
			setBrokenImage(false);
		}
	}, [props.authorImage]);


	const getInitials = () => {
		let {authorName, initials} = props;
		if (authorName && !initials) {
			let name = authorName,
				names = name.split(' '),
				initials = names[0].substring(0, 1).toUpperCase();

			if (names.length > 1) {
				initials += names[names.length - 1].substring(0, 1).toUpperCase();
			}

			return initials;
		} else if (initials) {
			return initials;
		}
	};

	const handleImageError = () => {
		setBrokenImage(true);
	};

	const getAuthorImage = (avatar) => {
		if (avatar && !avatar.match(/data:image/ig)) {
			if (avatar.match(/http:\/\/|https:\/\//ig)) {
				return avatar;
			} else {
				return `/api/v1/next/avatar/${avatar}`;
			}
		}

		return avatar;
	};

	let classes = styles(),
		{useIconFallback, primary, authorImage, sizeFactor, className, forceInitials} = props,
		initials = getInitials(),
		moreContrast = AuthorizedUser.wantsMoreContrast(),
		circleColorClass = primary ? classes.primaryCircleColor : moreContrast ? classes.moreContrastCircleColor : classes.defaultCircleColor,
		textColorClass = moreContrast ? classes.moreContrastText : primary ? classes.primaryTextColor : classes.defaultTextColor,
		avatarSizeClass = sizeFactor > 1 ?
			sizeFactor === 2 ? classes.avatarBigger
				: classes.avatarBiggest
			: sizeFactor === 0 ? classes.avatarSmaller
				: sizeFactor < 0 ? classes.avatarSmallest : classes.avatar;

	authorImage = getAuthorImage(authorImage);

	return !authorImage || brokenImage || forceInitials ? (
		<div className={`${className} ${avatarSizeClass} ${useIconFallback ? classes.iconFallbackContainer : ""}`}>
			{useIconFallback ? (
				<FontAwesomeIcon
					icon={["fal", "user"]}
					size={sizeFactor > 0 ? `${sizeFactor * 3}x` : null}
					title="missing profile photo"
					className={`${className} ${classes.iconFallback} ${avatarSizeClass}`} />
			) : (
				<span
					style={{fontSize: `${sizeFactor}rem`}}
					className={`${className} ${classes.avatarInitials} ${avatarSizeClass} ${textColorClass}`}>{initials}</span>
			)}
			<div className={`${className} ${classes.circle} ${avatarSizeClass} ${circleColorClass}`}></div>
		</div>
	) : (
		<MUIAvatar
			src={authorImage}
			onError={handleImageError}
			imgProps={{"alt": "user profile image"}}
			className={`${className} ${avatarSizeClass}`} />
	);
}

Avatar.defaultProps = {
	sizeFactor: 1
};

Avatar.propTypes = {
	className: PropTypes.string,
	authorName: PropTypes.string,
	authorImage: PropTypes.string,
	initials: PropTypes.string,
	primary: PropTypes.bool,
	forceInitials: PropTypes.bool,
	useIconFallback: PropTypes.bool,
	sizeFactor: PropTypes.number
};

export default Avatar;